import { throwGlobal } from '@goodt-wcore/errors';
import { HttpBase } from './HttpBase';

/**
 * HTTP Transport Client implementation
 * with Axios HTTP Client underhood
 * and extra service-specific behaviour
 *
 * @implements {import('./types').ITransportConstructor}
 * @extends {HttpBase}
 */
export class Http extends HttpBase {
    /**
     * @type {boolean}
     * @protected
     */
    _globalError = true;

    constructor(transportOptions = {}, extraOptions = {}) {
        super(transportOptions, extraOptions);
        if (extraOptions.globalError != null) {
            this._globalError = extraOptions.globalError;
        }
    }

    request({ url, method, params, options, responseHandler }) {
        return super.request({ url, method, params, options, responseHandler }).catch((processedError) => {
            /* Extra error throw in macrotask (that not breaking current callstack)
             * to be handled globally with window.addEventListener('unhandledrejection', ...)
             * for global Error Management
             */
            const shouldThrowGlobal =
                options?.globalError === true || (options?.globalError == null && this._globalError === true);
            if (shouldThrowGlobal) {
                throwGlobal(processedError, { context: this.request });
            }

            throw processedError;
        });
    }
}

export { Http as default };
